<template>
  <div id="pageContent">
    <div id="formArea" class="borderBox">
      <div id="autoButtonWrap">
        <button v-on:click="connectSocket" v-if="ws==null">Подключиться</button>
        <button v-on:click="connectSocketLocal" v-if="ws==null && canAccessThis('3')">Подключиться localhost</button>
        <button v-on:click="disconnectSocket" v-else>Отключиться</button>

        <button v-on:click="onPauseNextCall" v-if="canSetPause">Поставить на паузу</button>
        <button v-on:click="offPauseNextCall" v-if="canStopPause">Снять с паузы</button>
                <button v-on:click="startAutoCall" v-if="canAccessThis('4')">Начать автодозвон global</button>
                <button v-on:click="stopAutoCall" v-if="canAccessThis('4')">Остановка автодозвона global</button>
      </div>
      <div id="autoStats">
        <p><span>Статус автодозвона:</span> <span v-if="ADEnable.ADEnable">Включен</span><span v-else>Отключен</span></p>
        <p><span>Кол-во операторов</span> <span>{{ADEnable.memQCount}}</span></p>
        <p><span>Кол-во операторов на паузе</span> <span>{{ADEnable.memQCount_paused}}</span></p>
        <p><span>Лимит очереди звонков</span> <span>{{ADEnable.callQLimit}}</span></p>
        <p><span>Текущее кол-во номеров в очереди</span> <span>{{ADEnable.callQCount}}</span></p>
      </div>
      <div v-if="wsReturnError">
        <p>!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!</p>
        <h1>Что то пошло не так</h1>
        <div>{{wsReturnErrorDescription}}</div>
        <button v-on:click="wsReturnError = false">убрать эту абракадабру</button>
        <ul>
          <li v-for="item in socket.msg_list.slice(-20).reverse()">{{item}}</li>
        </ul>
        <br>
        <br>
        <p>!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!</p>
      </div>
      <div>
        <p>Статус соединения: {{socket.statusMsg}}</p>
        <p v-html="curentAction"></p>
      </div>


      <div id="operatorGetLead" v-if="Object.keys(leadTmp).length > 0">
        <div class="fl frstShortSeconLong" id="headOutgoing">
          <div>
            <div class="input_box">
              <label class="left">Тип продукта</label>
              <select v-model="productId">
                <option :value="option.ProductType" v-for="option in getProduct">{{option.DlProductTypeName}}</option>
              </select>
            </div>
            <div class="input_box">
              <label class="left">Сумма займа</label>
              <select v-model="requestSum">
                <option :value="Amount" v-for="Amount in getAvailableSum">{{Amount}}</option>
              </select>
            </div>
            <div class="input_box" v-show="getAvailablePeriod.length > 1">
              <label class="left">Срок займа {{getSelectedPskInfo.calcWeekTitle}}</label>
              <select v-model="CALC_WEEK">
                <option :value="Period" v-for="Period in getAvailablePeriod">{{Period}}</option>
              </select>
            </div>
          </div>
          <div>
            <p>Тип обзвона: <b>{{leadGroupName}}</b></p>
            <p>Фио клиента: <b>{{displayName}}</b></p>
          </div>
        </div>
        <productInfo></productInfo>
        <statusBar :typeCall="leadGroupName" v-on:loadNewLead="loadNewLead"  v-on:loadNewLeadWithPause="loadNewLeadWithPause"></statusBar>
        <formRequest v-on:loadNewLead="loadNewLead" v-on:loadNewLeadWithPause="loadNewLeadWithPause"></formRequest>
      </div>


    </div>

    <div class="borderBox" id="operatorScript">
      <OperatorScriptLayout :type="'outgoing'" :parentID="'0'"></OperatorScriptLayout>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  export default {
    name: "autoCC",
    data() {
      return {
        tiktak:0,
        ws: null,
        wsurl:'wss://ws.msk.finmoll.com:8444',
        socket: {
          statusMsg: '',
          msg_list: []
        },
        leadTmp: {},
        wsReturnError:false,
        wsReturnErrorDescription:'',
        onPause: false,
        ADEnable:{
          ADEnable:null,
          memQCount:null,
          memQCount_paused:null,
          callQLimit:null,
          callQCount:null
        },
      }
    },
    components: {
      formRequest: () => import('@/components/forms/formRequest'),
      statusBar: () => import('@/components/status/statusBar'),
      productInfo: () => import('@/components/productInfo'),
      OperatorScriptLayout: () => import('@/components/OperatorScript/OperatorScriptLayout'),
    },
    methods:{

      loadOperatorScript:function () {
        if (this.getIncomeScripts.length == 0) {
          this.$myApi.scriptContent()
          .then((result)=>{
            this.$store.dispatch('setScripts',result)})
          .catch((msg)=>{console.log(msg)});
        }
      },
      connectSocketLocal(){
        this.wsurl = 'wss://localhost:80';
          this.connectSocket();
      },
      addLog(value, fromTo) {
        let forSave = {
          index: this.socket.msg_list.length,
          data: value,
          fromTo: fromTo
        };
        if (this.socket.msg_list.length > 15) {
          this.socket.msg_list.slice(0, this.socket.msg_list.length - 15)
        }
        this.socket.msg_list.push(forSave);
      },
      connectSocket(){
        if (this.getProfile.work_tel == undefined) {
          this.addLog('Проблема с рабочим номером телефона, не удалось загрузить', 'front');
          return false;
        } else {
          this.addLog('TMP DEBUG work_tel:' + this.getProfile.work_tel, 'front');
        }
        let testSendSocet = [
          {action:'actionType', value:'connect' },
          {action:'phone', value: this.getProfile.work_tel },
          {action:'queueName', value:'5102' },
          {action: 'pause', value: '1'}
        ];


        let self = this;
        this.ws = new WebSocket(this.wsurl);
        this.ws.onopen = function () {
          self.socket.statusMsg = 'Соединение установлено.';
          self.addLog(testSendSocet, 'toWS');
          self.ws.send(JSON.stringify(testSendSocet));
        };

        this.ws.onclose = function (event) {
          if (event.wasClean) {
            self.socket.statusMsg = 'Соединение закрыто чисто';
          } else {
            self.socket.statusMsg = 'Обрыв соединения';
          }
          console.log(event)
          self.addLog('<br/>' + 'Код: ' + event.code + ' причина: ' + event.reason, 'from WS');
        };

        this.ws.onmessage = function (event) {
          self.addLog(event.data, 'from WS');
          try {
            let response = JSON.parse(event.data);
            self.cathMethod(response);
            console.log(response.Code);
            if (response.Code < 0) {
              self.wsReturnError = true;
              self.wsReturnErrorDescription = response.Message;
            }
            // if (response.Code > 0) {
            //   self.$store.commit('showModal');
            //   self.$store.commit('setContent', response.Message);
            //   self.$store.commit('userCanCloseModal');
            // }
          } catch (e) {
            self.wsReturnError = true;
            self.wsReturnErrorDescription = e;
          }
        };

        this.ws.onerror = function (error) {
          self.addLog(error, 'front Socet Error');
          self.wsReturnError = true;
          self.wsReturnErrorDescription = error.message;
        };
      },
      disconnectSocket(){
        this.ws.close();
        this.ws = null;
      },
      onPauseNextCall() {
        let sendData = [
          {action:'actionType', value:'onPauseNextCall' },
          {action:'phone', value: this.getProfile.work_tel },
          {action:'queueName', value:'5102' },
          {action: 'pause', value: '1'}
          ];
        this.addLog(sendData, 'to WS');
        this.ws.send(JSON.stringify(sendData));
      },
      offPauseNextCall() {
        let sendData = [
          {action:'actionType', value:'offPauseNextCall' },
          {action:'phone', value: this.getProfile.work_tel},
          {action:'queueName', value:'5102' },
          {action: 'pause', value: '0'}
          ];
        this.addLog(sendData, 'to WS');
        this.ws.send(JSON.stringify(sendData));

      },
      stopAutoCall() {
        let sendData = [
          {action:'actionType', value:'stopAutoCall' },
          {action: 'enableAutoDial', value: '0'},
          {action:'phone', value: this.getProfile.work_tel},
          {action:'queueName', value:'5102' },
          ];
        this.addLog(sendData, 'to WS');
        this.ws.send(JSON.stringify(sendData));
      },
      startAutoCall() {
        let sendData = [
          {action:'actionType', value:'startAutoCall' },
          {action: 'enableAutoDial', value: '1'},
          {action:'phone', value: this.getProfile.work_tel},
          {action:'queueName', value:'5102' },
          ];
        this.addLog(sendData, 'to WS');
        this.ws.send(JSON.stringify(sendData));
      },
      cathMethod(eventData){
        try {
          //смотрим на тип события, проверяем есть ли нужный нам метод
          if (eventData.actionType == 'ClientInfo') {
            this.leadTmp = JSON.parse(eventData.Message);
            this.addLead();
          }
          if (eventData.actionType == 'ADInfo') {
            this.setADEnable(eventData.actionList);
          }
          if (eventData.actionType == 'connect') {
            console.group(eventData.actionType)
            let t = (eventData.Code == 0)? true:false;
            console.log(t);
            console.groupEnd(eventData.actionType)
            this.$store.commit('onPauseAutoDealer', (eventData.Code >= 0)? true:false)
          }
          if (eventData.actionType == 'onPauseNextCall') {
            console.group(eventData.actionType)
            let t = (eventData.Code == 0)? true:false;
            console.log(t);
            console.groupEnd(eventData.actionType)
            this.$store.commit('onPauseAutoDealer', (eventData.Code >= 0)? true:false)
          }
          if (eventData.actionType == 'offPauseNextCall') {
            console.group(eventData.actionType)
            let t = (eventData.Code == 0)? true:false;
            console.log(t);
            console.groupEnd(eventData.actionType)
            this.$store.commit('onPauseAutoDealer', (eventData.Code >= 0)? false:true)
          }
        } catch (e) {
          console.log(eventData);
          console.log(e);
          alert('!!!!! СКОПИРОВАТЬ и ОТПРАВИТЬ РАЗРАБОТЧИКУ !!!!! ->> ' + JSON.stringify(eventData) + ' #### ' +
            JSON.stringify(e));
        }

      },
      loadNewLead() {
        console.log('offPauseNextCall')
        this.$store.dispatch('resetToDefault');
        this.updateDeadType();
        this.leadTmp = {};
        this.offPauseNextCall();
      },
      loadNewLeadWithPause() {
        this.$store.dispatch('resetToDefault');
        this.updateDeadType();
        this.leadTmp = {};
      },
      addLead() {
        /*status*/
        this.onPauseNextCall();

        this.$store.dispatch('resetToDefault');
        this.updateDeadType();
try {

  this.leadTmp.REFFER = 'Телемаркетинг';
  this.leadTmp.WHERE_TO_FIND_US = this.leadTmp['LeadType'];
  this.$store.dispatch('saveSendData', {
    target: 'requestType',
    form: 'status',
    value: 'outgoing'
  });

  /*status*/
  /*lead main data*/
  this.$store.dispatch('setRequestField', {
    form: 'request',
    values: this.leadTmp
  });

  /*lead main data*/
  /*lead main system*/
  this.$store.dispatch('setRequestField', {
    form: 'LeadInfo',
    values: this.leadTmp
  });

  /*lead main system*/
  /*lead old data from prev call*/

  if (typeof this.leadTmp['LeadData'] === 'object' && this.leadTmp['LeadData']['request'] != undefined) {
    this.$store.dispatch('setRequestField', {
      form: 'request',
      values: this.leadTmp['LeadData']['request']
    })
  }
  /*lead old data from prev call*/
} catch (e) {
  console.log(e)
}

      },
      updateDeadType() {
        //надо бы переписать, что бы кровь из глаз не шла
        return new Promise((resolve, reject) => {
          this.$myApi.SendRequest({action: 'Operator_Get_Ref_DealType'}, this, 'mountedPsk', false)
          .then((result) => {
            if (result.length > 0) {
              //если есть массив, значит пришли новые продукты, добавляем в фронт и сохроняем к нам в бд
              this.$store.dispatch('addPskTable', result);
              this.$myApi.saveDefaultDealType(result).then(() => {
                resolve();
              }).catch(e => {
                console.log(e);
                reject();
              });
            } else {
              this.$myApi.getDefaultDealType()
              .then((result) => {
                this.$store.dispatch('addPskTable', result);
                resolve();
              })
              .catch(e => {
                console.log(e);
                reject();
              });
            }
          }).catch(e => {
            console.log(e);
            alert('Ошибка :' + e);
          });
        });
      },
      setADEnable(value){
        value.forEach((item)=>{
          switch (item.action) {
            case 'ADEnable':
              this.ADEnable[item.action] = item.value;
              break;
            case 'memQCount':
              this.ADEnable[item.action] = item.value;
              break;
            case 'memQCount_paused':
              this.ADEnable[item.action] = item.value;
              break;
            case 'callQLimit':
              this.ADEnable[item.action] = item.value;
              break;
            case 'callQCount':
              this.ADEnable[item.action] = item.value;
              break;
            default: break;
          }

        });
      }
    },
    mounted(){
      this.updateDeadType();
      this.loadOperatorScript();


    },
    created() {

    },
    watch:{
    },
    computed: {
      reverse: function () {
        return this.socket.msg_list.sort((a, b) => b.index - a.index );
      },
      ...mapGetters(['getProfile', 'getProduct', 'getAvailableSum', 'getIncomeScripts', 'getAvailablePeriod',
        'getSelectedPskInfo', 'canAccessThis']),
      ...mapState({
        valueVuex: state => state.requestField['sendData'],
        leadGroupName: state => state.requestField['sendData']['LeadInfo']['LeadType'],
        pauseAutoDealer: state => state.pauseAutoDealer,
      }),
      productId: {
        get() {
          return this.valueVuex['request']['PRODUCT_ID']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'PRODUCT_ID',
            form: 'request',
            value: value
          });
        }
      },
      requestSum: {
        get() {
          return this.valueVuex['request']['CALC_SUMM']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'CALC_SUMM',
            form: 'request',
            value: value
          });
        }
      },
      CALC_WEEK: {
        get() {
          return this.valueVuex['request']['CALC_WEEK']
        },
        set(value) {
          this.$store.dispatch('saveSendData', {
            target: 'CALC_WEEK',
            form: 'request',
            value: value
          });
        }
      },
      displayName: function () {
        return this.valueVuex['request']['LAST_NAME'] + ' ' + this.valueVuex['request']['FIRST_NAME'] + ' ' + this.valueVuex['request']['SECOND_NAME'];
      },
      curentAction(){
        console.log(this.pauseAutoDealer)
        return (Object.keys(this.leadTmp).length == 0 && this.ws != null && !this.pauseAutoDealer)
          ? '<span>Идет поиск клиента</span>' : (this.pauseAutoDealer)
            ? '<span style="color:red;">Вы в режиме пауза</span>' : ''
      },
      canSetPause() {
        console.log('canSetPause')
        return this.socket.statusMsg == 'Соединение установлено.' && !this.pauseAutoDealer;
      },
      canStopPause(){
        console.log('canStopPause')
        return this.socket.statusMsg == 'Соединение установлено.' && this.pauseAutoDealer;
      },

    }
  }
</script>

<style scoped>

  button {display: block;margin: 10px;}
  #logsocet {height: 200px;overflow: scroll}


  #headOutgoing{align-items: center;text-align: left;padding: 0 0 20px;}
  #headOutgoing p {margin: 0;padding: 0;}
  #pageContent{display: flex;align-items: flex-start;justify-content: flex-start;width: 100%;}
  #formArea{width: 900px;}
  #autoButtonWrap {display: flex;flex-wrap: wrap;}
  @media screen and (max-width: 1600px){
    #pageContent{position: absolute;height: auto;}
  }
  .loaderWrap{min-height: 66vh;height: 1px;}
  #operatorScript{    margin: 0;
    width: calc(100% - 1070px);
    text-align: left;
    position: fixed;
    top: 10px;
    right: 10px;
    height: calc(100vh - 40px);
    overflow-x: scroll;}
  #startCall{margin-top: 30px;}
  .callingBox{justify-content: flex-start;align-items: center}
  .callingBox .button{border: 6px solid;border-top:12px solid;margin: 0 10px}

  #autoStats{text-align: left;}
  #autoStats span{display: inline-block}
  #autoStats span:first-child{width: 250px;}
</style>
